module.exports = __webpack_public_path__ + "static/media/5_9.96caee31.png";